import components from "./components";
import civitaiLoraItem from "../civitai/civitai-lora-item";
export default function () {
    components();
    civitaiLoraItem();
}